// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgHome24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5 10.9781V20C19.5 20.2761 19.2761 20.5 19 20.5H15V14C15 13.4477 14.5523 13 14 13H10C9.44772 13 9 13.4477 9 14V20.5H5C4.72386 20.5 4.5 20.2761 4.5 20V10.9781C4.5 10.8238 4.57124 10.6782 4.69303 10.5835L11.693 5.13901C11.8736 4.99858 12.1264 4.99858 12.307 5.13902L19.307 10.5835C19.4288 10.6782 19.5 10.8238 19.5 10.9781ZM10.5 20.5V14.5H13.5V20.5H10.5ZM9.9921 22H5C3.89543 22 3 21.1045 3 20V10.9781C3 10.361 3.28495 9.77834 3.77212 9.39943L10.7721 3.95499C11.4943 3.39326 12.5057 3.39326 13.2279 3.95499L20.2279 9.39943C20.7151 9.77834 21 10.361 21 10.9781V20C21 21.1045 20.1046 22 19 22H14.0079C14.0053 22 14.0026 22 14 22H10C9.99737 22 9.99473 22 9.9921 22Z"
			/>
		</Svg>
	);
});
SvgHome24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgHome24;
